import { getApigeeUrl } from '../selectors/getBaseUrlSelectors';
import { getStarEligibility } from './getStarEligibility';

export const fetchOptions = {
  mode: 'cors',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'X-AMEX-REQUEST-ID': 'vacationRentalsTbds',
    'Accept-Encoding': 'application/xml',
    clientid: 'TLS-VR',
  },
};

export function readBenefits(state, fetchClient = fetch) {
  const apigeeDomain = getApigeeUrl(state);
  const url = `${apigeeDomain}/travel/v2/travel_services/tbs/benefits`;
  // This fetch call is needed as iguazu does not work within onEnter hooks
  // since the api call is made at the root level.
  return fetchClient(url, fetchOptions)
    .then((response) => response.json()
      .then((data) => {
        if (getStarEligibility(data)) {
          return true;
        }
        return false;
      })).catch(() => false);
}
